import React, { useContext, useEffect, useState } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'
import {
  Container,
  Flex,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Grid,
} from '@chakra-ui/react'
import { H1, H2, H3, H4, H6, Span } from '../theme/Headings'
import { spacing, breakpoints, colors, hexToRGB, typography } from '../theme/themeAlopex'
import ColorContext from '../context/ColorContext'
import RipplingAK from '../components/RipplingAK'
// Services
// import SVGStrategy from '../images/services/strategy.inline.svg'
import Marketing from '../components/Services/Marketing'
import Design from '../components/Services/Design'
import Digital from '../components/Services/Digital'
// Newsletter
import Newsletter from '../components/Newsletter'
// gsap
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/all'
import Marquee from "../components/Marquee"
import HubSpot from "../components/HubSpot"
import FooterPioneer from "../components/Footer-Pioneer"
import LogosGrid from "../components/LogosGrid"
import {ServiceSlider} from "../components/ServiceSlider"

// Register gsap plugins
gsap.registerPlugin(ScrollTrigger)

const IndexPage2024 = ({ data }) => {
  const { color } = useContext(ColorContext)
  const [isDesktop2, setDesktop2] = useState(false)

  const differences = [
    {
      title: 'Results Focused',
      answer: 'Here’s a nasty secret: many agencies simply don’t know if what they are doing makes sense. Even worse, TV companies don’t know how many people see commercials, newspapers don’t know how many people actually read their pages, and radio stations don’t know how many people flip the channel when a lineup of ads start.\n\n The point of marketing is to get results and the only way to know you are getting results are numbers. Whether by using focus groups, surveys, analytics or any other scientific means, we will prove to you that every dollar you spend with us comes back to your business—with more.\n\n If something doesn’t work, we aren’t going to spend your money there.'
    },
    {
      title: 'Quality',
      answer: 'Our design and marketing work is meticulous and beautiful. Our team is made up of very talented Alaskans who are hand picked out of their field. We don’t outsource and we don’t simply install templates. If you hire Alopex for Search Engine Optimization, we don’t send it out to another company, it’s done here, in our office, to our standards.\n\n It’s important to us that our clients value the standard of our work. Marketing, like any other service, is an area where you get what you pay for.'
    },
    {
      title: 'Honesty',
      answer: 'We’ve heard the stories of how our clients were treated before they came to Alopex.\n\n Working with Alopex, you are our partner. We will work with you in whatever capacity you need. We have time to talk to you in person, and we will never blow smoke in your eyes. It’s your business, it’s your money, and we want you to see what we are doing with it.'
    },
    {
      title: 'Qualified',
      answer: 'The Alopex team holds degrees and certifications in our areas of expertise. The majority of our crew is Google certified in Google Ads, Analytics, Mobile Development, and a myriad of other topics.\n\n We’ve been building extraordinary marketing experiences for Alaskans since 2012. We’ll be happy to provide you with case studies, numbers, and references.'
    }
  ]

  // Clear transform matrix from transition wrapper interfering with nested fixed header
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const tlWrapper = document.querySelector('.tl-wrapper-status--entered')
      if (tlWrapper !== null) {
        tlWrapper.style.transform = null
      }
    }
  })
  
  const ogImage = !!data.contentJson.seoFields.ogImage ? `https://www.alopexid.com${data.contentJson.seoFields.ogImage.replace('/static', '')}"` : null

  const updateMedia = () => {
    if (window.innerWidth > 960) {
      setDesktop2(true);
    } else {
      setDesktop2(false);
    }
  }
  useEffect(() => {
    // console.log('useeffect triggered so wtf?', isDesktop2)
    updateMedia()
    window.addEventListener('resize', updateMedia)
    return () => window.removeEventListener('resize', updateMedia)
  }, [])

  useEffect(() => {

  }, [isDesktop2])

  return (
    <Layout>
      <SEO title={data.contentJson?.seoFields?.seoTitle} description={data.contentJson?.seoFields?.seoDesc} ogImage={ogImage} />
      {/* SERVICES HEADER */}
      <Box overflow="hidden">

        <Box position="relative" marginTop="45px" mb={['500px', null, '600px']}
          sx={{
            '&::before': {
              content: '""',
              position: 'absolute',
              bottom: '-35%',
              left: '-30%',
              height: '100vw',
              width: '100vw',
              minHeight: '1440px',
              minWidth: '1440px',
              // background: `linear-gradient(135deg, ${color.alpha} 40%, ${hexToRGB(color.bravo, 0.5)})`,
              backgroundColor: color.alpha,
              borderRadius: '9999px',
              zIndex: 1
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: '-65%',
              right: '-10%',
              height: '100vw',
              width: '100vw',
              minHeight: '1440px',
              minWidth: '1440px',
              backgroundColor: color.bravo,
              mixBlendMode: 'overlay',
              borderRadius: '9999px',
              zIndex: 2
            }
          }}
        >
          <Container
            position="relative"
            maxWidth={breakpoints.xl}
            padding={[`1rem 1rem`, null, null, null, '100px 1rem 0']}
            zIndex="5"
          >
            {/* SPLINE */}
            <Box
              mb={spacing.icon}
              sx={{
                '.splineBox': {
                  width: '100%',
                  height: '40vh',
                }
              }}
            >
              <div className="splineBox" dangerouslySetInnerHTML={{ __html: '<iframe src="https://my.spline.design/PMcrz3g6C-TlVDF660-qKouK/" frameBorder="0" width="100%" height="100%"></iframe>' }} />
            </Box>
            {/* KICKER */}
            <Box textAlign="center">  
              <H2 variant="figtreeSm" color={hexToRGB('#ffffff', 0.5)}>A creative fusion reactor powering client success</H2>
              <H1 variant="figtreeHome" color="white">Alopex is a full-service digital marketing agency.</H1>
            </Box>

          </Container>
        </Box>
        <Container maxWidth={breakpoints.xl} pb={[spacing.groups, null, spacing.section]} textAlign="center">
          <H2 variant="figtree" mb="0">We are creatives and programmers who work together, providing premium marketing solutions with superior performance.</H2>
        </Container>

        <Box>
          <LogosGrid />
        </Box>
        <Box id="our-services" mb={spacing.section} />

        {/* SERVICES */}
        <Container maxWidth={breakpoints.xl}>
          <Box textAlign="center" mb={spacing.groups}>  
            <Span variant="figtreeSm" color={hexToRGB(colors.brand.slate, 0.3)}>Our Services</Span>
            <H2 variant="figtree">We deliver what other marketing agencies can’t.</H2>
            <p>Hover over our core services for a list of service-specific pages.</p>
          </Box>
        </Container>

        {!isDesktop2 && (
          <Box pb={[spacing.groups, null, spacing.section]} sx={{'--alpha': color.alpha, '--bravo': color.bravo }}>
            <ServiceSlider />
          </Box>
        )}

        <Container maxWidth={breakpoints.xl} pb={[spacing.groups, null, spacing.section]} sx={{'--alpha': color.alpha, '--bravo': color.bravo }}>
          {isDesktop2 && (
            <Grid
              gridGap="64px"
              templateColumns="1fr 1fr 1fr"
              sx={{
                '.svcColumn': {
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    height: 'calc(100% - 150px)',
                    width: '1px',
                    backgroundColor: 'rgba(151, 151, 151, 0.33)',
                    right: '-32px',
                    bottom: 0
                  }
                },
                '.svcBox': {
                  marginBottom: '32px',
                  perspective: '1000px', /* Remove this if you don't want the 3D effect */
                  maxHeight: '200px',
                  height: '200px',
                  transition: 'all 0.6s ease-in-out',
                  '.svcBoxInner': {
                    height: '100%',
                    maxHeight: '100%',
                    transition: 'all 0.6s ease-in-out',
                    boxShadow: 'rgb(255, 255, 255) -3px -3px 8px 1px, rgb(167, 179, 185) 3px 3px 8px 2px',
                    background: 'linear-gradient(135deg, #f1f1f1, #e5e5e5)',
                    borderRadius: '24px',
                    position: 'relative',
                    transition: 'transform 0.6s',
                    transformStyle: 'preserve-3d',
                    overFlow: 'hidden',
                    '.svcBoxFront, .svcBoxBack': {
                      padding: '42px 25px',
                      inset: 0,
                      '-webkit-backface-visibility': 'hidden',
                      backfaceVisibility: 'hidden'
                    },
                    '.svcBoxFront': {
                      position: 'absolute'
                    },
                    '.svcBoxBack': {
                      position: 'absolute',
                      transform: 'rotateY(180deg)',
                      minHeight: '200px',
                      ul: {
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        pl: '20px',
                        pt: '8px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                        position: 'relative',
                        li: {
                          color: 'rgba(0, 0, 0, 0.1)',
                          background: `-webkit-linear-gradient(right, ${color.bravo}, ${color.alpha})`,
                          WebkitBackgroundClip: 'text',
                          display: 'inline-block',
                          position: 'relative',
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: '50%',
                            right: 'calc(100% + 4px)',
                            transform: 'translateY(-50%)',
                            width: '14px',
                            height: '3px',
                            borderTop: `1px dotted ${color.alpha}`
                          },
                          a: {
                            display: 'block',
                            // textDecoration: 'none'
                          }
                        },
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 'calc(100% - 12px)',
                          borderLeft: `1px dotted ${color.alpha}`
                        }
                      }
                    }
                  },
                  '&:hover': {
                    maxHeight: '1000px',
                    height: 'auto',
                    '.svcBoxInner': {
                      transform: 'rotateY(180deg)',
                      '.svcBoxBack': {
                        position: 'relative',
                      }
                    }
                  }
                }
              }}
            >
              <Box className="svcColumn">
                <Box maxHeight="100px" maxWidth="100px" mb={spacing.icon}>
                  <Marketing />
                </Box>
                <Box maxWidth="70%" mb="50px">
                  <H3 variant="figtree">Marketing</H3>
                  <p>The efforts put forth to reach the goals of your organization.</p>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Strategy</H6>
                      <Box as="p" mb="0">You are an expert in your field, let us lend you our expertise in crafting effective marketing strategy.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Strategy</H6>
                      <ul>
                        <li><a href="/services/sem-services/">Premium SEM Services</a></li>
                        <li><a href="/services/branding/">Premium Brand Design</a></li>
                        <li><a href="/services/seo-services/">Premium SEO Services</a></li>
                        <li><a href="/services/marketing-strategy/">Marketing Strategy, Planning and Execution</a></li>
                      </ul>
                      
                    </Box>
                  </Box>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Content</H6>
                      <Box as="p" mb="0">Our team of creatives produces beautiful and valuable video, graphics, and writing everyday.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Content</H6>
                      <ul>
                        <li><a href="/services/seo-services/">Premium SEO Services</a></li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Design</H6>
                      <Box as="p" mb="0">Alopex is unyielding in our pursuit of excellence in graphic design across mediums.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Design</H6>
                      <ul>
                        <li><a href="/services/branding/">Premium Brand Design</a></li>
                        <li><a href="/services/print/">Print Design Services</a></li>
                        <li><a href="/services/ui-ux-designers/">UI & UX Design</a></li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box className="svcColumn">
                <Box maxHeight="100px" maxWidth="170px" mb={spacing.elements} mt="-30px">
                  <Design />
                </Box>
                <Box maxWidth="85%" mb={spacing.elements}>
                  <H3 variant="figtree">Experiences</H3>
                  <p>Award-winning expressions of your brand in digital and physical spaces.</p>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Websites</H6>
                      <Box as="p" mb="0">From research, to design, to testing, our in-house team of designers and developers craft exceptional websites.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Websites</H6>
                      <ul>
                        <li><a href="/services/custom-website-developers/">Custom Websites</a></li>
                        <li><a href="/services/squarespace-website-designer/">Premium Squarespace Website Designers</a></li>
                        <li><a href="/services/seo-services/">Premium SEO Services</a></li>
                        <li><a href="/services/website-support-management/">Website Support &amp; Management</a></li>
                        <li><a href="/services/api-integration-services/">API Integration</a></li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Apps</H6>
                      <Box as="p" mb="0">Whether you need to discuss the feasibilty of a concept or are looking for a team of programmers, we have you covered.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Apps</H6>
                      <ul>
                        <li><a href="/services/api-integration-services/">API Integration</a></li>
                        <li><a href="/services/ui-ux-designers/">UI & UX Design</a></li>                      
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box className="svcColumn">
                <Box maxHeight="100px" maxWidth="150px" mb="40px" mt="-20px">
                  <Digital />
                </Box>
                <Box maxWidth="85%" mb={spacing.elements}>
                  <H3 variant="figtree">Technical</H3>
                  <p>Alopex&rsquo;s technical offerings that allow us to provide extended services.</p>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Software</H6>
                      <Box as="p" mb="0">A department of Alopex devoted to building and maintaining software and integrations for enterprises.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Software</H6>
                      <ul>
                        <li><a href="/services/api-integration-services/">API Integration</a></li>
                        <li><a href="/services/ui-ux-designers/">UI & UX Design</a></li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
                <Box className="svcBox">
                  <Box className="svcBoxInner">
                    <Box className="svcBoxFront">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Digital Advertising</H6>
                      <Box as="p" mb="0">Alopex yields industry-breaking results for our clients by leveraging our programmers and creatives on every campaign.</Box>
                    </Box>
                    <Box className="svcBoxBack">
                      <H6 fontFamily={typography.fonts.body} color={color.alpha} textTransform="uppercase" fontWeight="700" letterSpacing="1.2px" fontSize="1rem">Digital Advertising</H6>
                      <ul>
                        <li><a href="/services/seo-services/">Premium SEO Services</a></li>
                        <li><a href="/services/custom-website-developers/">Custom Websites</a></li>
                        <li><a href="/services/sem-services/">SEM Advertising</a></li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          )}
        </Container>
        
        {/* MARQUEE */}
        <Box borderTop={`1px solid ${hexToRGB(colors.brand.slate, 0.5)}`} borderBottom={`1px solid ${hexToRGB(colors.brand.slate, 0.5)}`}>
          <Marquee direction="left" displayed="9"/>
        </Box>
        <Box borderBottom={`1px solid ${hexToRGB(colors.brand.slate, 0.5)}`}>
          <Marquee direction="right" displayed="9"/>
        </Box>

        {/* HUBSPOT */}
        <Box mb={[spacing.groups, null, spacing.section]} overflow="hidden">
          <HubSpot
            embedURL="https://meetings.hubspot.com/alopexkyle/inbound-meeting?embed=true"
            superTitle="Let's Chat"
            title="Come get a coffee, or join us online."
            blurb="No matter where you’re at in your journey, we’re happy to have a conversation with you. Even if we aren’t the best fit, we enjoy meeting new people to hear their stories and ideas. Owner Kyle Fox and Account Executive Bobby Burns work directly with clients to ensure their success. If you neet to schedule a meeting further in advance, please us our [inquiry](/contact/) form."
          />
        </Box>

        {/* DIFFERENCE ACCORDION */}
        <Container maxWidth="850px" mb={[spacing.groups, null, spacing.section]}>
          <Box maxWidth={breakpoints.md} mb="30px">
            <H2 variant="figtreeSm" color={hexToRGB(colors.brand.slate, 0.3)}>Our Policy</H2>
            <H2 variant="figtree">What makes us different</H2>
          </Box>
          <Accordion
            allowToggle
            maxW="850px"
            sx={{
              '.accItem': {
                background: 'linear-gradient(180deg, #f1f1f1, #ffffff)',
                marginBottom: '1rem',
                borderRadius: '20px',
                position: 'relative',
                border: 'none',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: '-1px',
                  boxShadow: '-4px -4px 10px 1px white, 4px 4px 12px 1px #a7b3b9',
                  background: `linear-gradient(to right, ${hexToRGB(color.alpha, 0.15)}, ${hexToRGB(color.alpha, 1)})`,
                  borderRadius: '21px',
                  zIndex: '-1'
                },
                button: {
                  padding: '1.5rem'
                },
                h4: {
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  fontSize: '1.25rem',
                },
                p: {
                  maxWidth: '600px'
                },
                '.accPanel': {
                  padding: '0.25rem 1.5rem 1.25rem 1.5rem'
                }
              }
            }}
          >
            {differences.map((svc, i) => {
              return (
                <AccordionItem className="accItem">
                  {({ isExpanded }) => (
                    <>
                      <AccordionButton _focus={{boxShadow: 'none'}} _hover={{backgroundColor: 'transparent'}} backgroundColor="transparent">
                        <H4 mb="0" width="100%" lineHeight="1" color={color.alpha}>
                          <Flex flex="1" textAlign="left" justifyContent="space-between" alignItems="center" gridGap="1rem">
                            {svc?.title}
                            {isExpanded ? (
                              <Flex justifyContent="center" alignItems="center" lineHeight="1" fontSize="35px" width="31px" height="31px" minWidth="31px" backgroundColor={color.alpha} borderRadius="999px" color="#f1f1f1" fontWeight="100">
                                <svg viewBox="0 0 12 12" width="14px" height="14px">
                                  <path d="M11.382,6.595H.595c-.331,0-.595-.265-.595-.595s.265-.595.595-.595h10.809c.331,0,.595.265.595.595-.022.331-.287.595-.618.595h0Z" fill="#fff" fillRule="evenodd" strokeWidth="0"/>
                                </svg>
                              </Flex>
                            ) : (
                              <Flex justifyContent="center" alignItems="center" lineHeight="1" fontSize="35px" width="31px" height="31px" minWidth="31px" backgroundColor={color.alpha} borderRadius="999px" color="#f1f1f1" fontWeight="100">
                                <svg viewBox="0 0 12 12" width="14px" height="14px">
                                  <path d="M11.382,6.595h-4.808v4.809c0,.331-.265.595-.595.595s-.595-.265-.595-.595v-4.809H.595c-.331,0-.595-.265-.595-.595s.265-.595.595-.595h4.809V.595c0-.331.265-.595.595-.595s.595.265.595.595v4.809h4.809c.331,0,.595.265.595.595-.022.331-.287.595-.618.595h0Z" fill="#fff" fillRule="evenodd" strokeWidth="0"/>
                                </svg>
                              </Flex>
                            )}
                          </Flex>
                        </H4>
                      </AccordionButton>
                      <AccordionPanel className="accPanel">
                        <ReactMarkdown remarkPlugins={[gfm]} children={svc?.answer} />
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              )
            })}
          </Accordion>
        </Container>

        {/* NEWSLETTER */}
        <Newsletter title="Hear from us" copy={data.contentJson.newsletterCopy} origin="services" />

        {/* ALASKA GROWN */}
        <Box
          p={[`${spacing.groups} 0`, null, `${spacing.section} 0`]}
          overflow="hidden"
          position="relative"
        >
          <RipplingAK />
          <Container maxWidth={breakpoints.lg}>
            <Span mb="10px" variant="figtreeSm" color={hexToRGB(colors.brand.slate, 0.3)}>Alaska Grown</Span>
            <H2 variant="figtree">World class work from Palmer, Alaska</H2>
            <Box as="p" maxWidth="600px">
            Alaska is one of the most beautiful places in the world. We believe that our design and code should be beautiful as well. When you choose to work with Alopex, you are choosing to work with locals who inherently understand your audience.
            </Box>
            <Box as="p" maxWidth="600px" mb="0">
              We do not outsource, we do not use templates. We are Alaskan creatives and computer scientists.
            </Box>
          </Container>
        </Box>
        <FooterPioneer fTitle="Let Alopex take you further." weather={data.openWeather} />
      </Box>
    </Layout>
  )
}

export const query = graphql`
  query aloHome2024 {
    site {
      siteMetadata {
        title
      }
    }
    contentJson(slug: {eq: "home"}) {
      title
      newsletterCopy
      strategyTitle
      strategyCopy
      strategyLink
      contentTitle
      contentCopy
      contentLink
      marketingTitle
      marketingCopy
      marketingLink
      designTitle
      designCopy
      designLink
      digExpTitle
      digExptCopy
      digExpLink
      listOfficeImages {
        officeImage
        officeImageLink
      }
      seoFields {
        seoTitle
        seoDesc
        ogImage
      }
    }
    allService2024Json {
      nodes {
        slug
        title
      }
    }
    openWeather {
      main {
        temp
      }
      sys {
        sunrise
        sunset
      }
    }
  }
`

export default IndexPage2024
